import React, { useState } from "react";
import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import SouthIcon from "@mui/icons-material/South";
import "./GenericSortItem.css";
import { OrderName, OrderPropery, SortItem, SortingOrder } from "./types";
import { useConfig } from "../../context/ConfigContext";

const GenericSortItem: React.FunctionComponent = () => {
  const { sortOrder, setSortOrder } = useConfig();

  return (
    <div className="genericSortItem">
      <FormControl fullWidth>
        <Select
          sx={{ width: 177 }}
          id="select-value"
          IconComponent={SouthIcon}
          value={sortOrder.name}
          label="Sort order"
          onChange={(event: SelectChangeEvent) => {
            const sortOrder = sortItems.find((i) => i.name === event.target.value);
            setSortOrder(sortOrder);
          }}
        >
          <MenuItem value={OrderName.RELEVANCY_DESC}>most relevant</MenuItem>
          <MenuItem value={OrderName.RELEVANCY_ASC}>least relevant</MenuItem>
          <MenuItem value={OrderName.DATE_DESC}>newest first</MenuItem>
          <MenuItem value={OrderName.DATE_ASC}>oldest first</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default GenericSortItem;

const sortItems: SortItem[] = [
  {
    order: SortingOrder.ASC,
    property: OrderPropery.DATE,
    name: OrderName.DATE_ASC,
  },
  {
    order: SortingOrder.DESC,
    property: OrderPropery.DATE,
    name: OrderName.DATE_DESC,
  },
  {
    order: SortingOrder.ASC,
    property: OrderPropery.RELEVANCY,
    name: OrderName.RELEVANCY_ASC,
  },
  {
    order: SortingOrder.DESC,
    property: OrderPropery.RELEVANCY,
    name: OrderName.RELEVANCY_DESC,
  },
];

export const defaultSortOrder = {
  order: SortingOrder.DESC,
  property: OrderPropery.RELEVANCY,
  name: OrderName.RELEVANCY_DESC,
};
